<!--
  @Description: 活跃机构
  @Author: wang.y 
  @Date: 2022-02-17 
-->
<template>
  <div class="company-table">
    <Table :columns="list_columns" :data="data">
      <template slot-scope="{ row, index }" slot="top">
        <img v-if="index < 3" :src="$store.state.static_img_url+'pic/top'+ (index + 1) +'.png'">
        <div v-else>{{index + 1}}</div>
      </template>
      <template slot-scope="{ row }" slot="name">
        <div class="comp-item">
          <div class="comp-logo" @click="goToDetail(row)">
            <img :src="row.logo_path | logo_show" />
          </div>
          <div class="comp-decs">
            <div class="p1 over-p1" @click="goToDetail(row)">{{row.short_name}}</div>
            <a :href="$store.state.index_path + '/orgDetail/' + row.uid"></a>
            <div class="p2 over-p1">{{row.description}}</div>
          </div>
        </div>
      </template>
      <template slot-scope="{ row }" slot="num">
        <div>{{row.event_num}}</div>
      </template>
      <template slot-scope="{ row }" slot="lingyu">
        <div class="over-p2">
          <span v-for="f, f_index in row.focus" :key="f_index">{{ f_index == row.focus.length -1 ? f.name : f.name + '、'}}</span>
        </div>
      </template>
    </Table>
  </div>
</template>
<script>
export default {
  props:['data'],
  components: {},
  created() {},
  mounted() {},
  data() {
    return {
      list_columns: [{
        title: '排名',
        slot: 'top',
        width: 60,
        align: 'center'
      },{
        title: '投资机构',
        slot: 'name',
        width: 200
      }, {
        title: '投资事件数',
        slot: 'num',
        width: 120
      }, {
        title: '关注领域',
        slot: 'lingyu'
      }],
      list_data: Array(4).fill({})
    }
  },
  computed: {
    static_img_url() {
      return this.$store.state.static_img_url
    },
  },
  methods: {
    goToDetail(item) {
      const { href } = this.$router.resolve({ name: 'OrgDetail', params: { uid: item.uid } })
      window.open(href, '_blank')
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common2.0.stylus'
</style>